export default __webpack_public_path__ + "static/Tapetsering3-b776eb1d216aa6481abe75540025d3f3.jpg";